export default __webpack_public_path__ + "static/media/Receipt.bb34e586.svg";